import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import AppHeader from './AppHeader';
import useUIStore from '../../stores/uiStore';

const { Content } = Layout;

const THEME = {
  sidebarBg: '#1B3A5C',
  sidebarActiveBg: '#3DA872',
  sidebarHover: '#1A6E8C',
  headerBg: '#FFFFFF',
  contentBg: '#F5F6FA',
  brandPrimary: '#1A6E8C',
  textOnDark: '#FFFFFF',
  textOnDarkMuted: '#B0C4D8',
} as const;

export default function AppLayout(): React.ReactElement {
  const collapsed = useUIStore((s) => s.sidebarCollapsed);
  const sidebarWidth = collapsed ? 80 : 250;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppSidebar />
      <Layout style={{ marginLeft: sidebarWidth, transition: 'margin-left 0.2s' }}>
        <AppHeader />
        <Content
          style={{
            padding: 24,
            minHeight: 'calc(100vh - 64px)',
            background: THEME.contentBg,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
